import React from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import pricingDataFaqs from "../data/pricingDataFaqs";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function PricingFAQs() {
    useScrollAnimation();
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    return (
        <div className="flex flex-col gap-[20px] p-6">
            <div className="flex flex-col gap-[4px]">
                <span className="font-bold text-[#294a6a] text-[25px] capitalize js-scroll fade-top">Pricing</span>
                <img className="h-fit w-[40px] js-scroll fade-btm" src={require("../../assets/icons/line.svg").default} alt="" />
            </div>
            <div className="space-y-4 ">
                {pricingDataFaqs.map((faq, index) => (
                    <div key={index} className="border rounded-xl p-4 shadow-md js-scroll fade-top">
                        <button
                            className="t-left w-full flex justify-between items-center text-lg font-medium"
                            onClick={() => toggleFAQ(index)}
                        >
                            {faq.question}
                            <motion.div
                                animate={{ rotate: openIndex === index ? 180 : 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <ChevronDown className="w-5 h-5" />
                            </motion.div>
                        </button>
                        {openIndex === index && (
                            <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                                className="mt-2 text-gray-600"
                            >
                                {faq.answer}
                                {faq.points && faq.points.length > 0 && (
                                    <ul className="list-disc pl-5">
                                        {faq.points.map((point, index) => (
                                            <li key={index}>{point}</li>
                                        ))}
                                    </ul>
                                )}
                            </motion.div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}